/**
 * Returns a date in YYYY-MM-DD format based on either:
 * - A number of months to add to today's date, OR
 * - A specific date string in YYYY-MM-DD format
 * @param {number | string | null | undefined} userInputValue - The number of months to add OR a specific date string | null | undefined
 * @returns {string | null | undefined} - The date in YYYY-MM-DD format | null | undefined
 */

const getLdsStartDate = (
  userInputValue: number | string | null | undefined,
): string | null | undefined => {
  if (typeof userInputValue === 'string') {
    userInputValue = Number(userInputValue);
  }

  if (userInputValue === undefined || userInputValue === null) {
    return userInputValue as null | undefined;
  }

  // If userInputValue is a number, add months to current date
  const date = new Date();
  date.setMonth(date.getMonth() + Number(userInputValue));

  return date.toISOString().split('T')[0];
};

export default getLdsStartDate;
